import { isDarkTheme } from 'UI/theme/darkTones';

import { componentDimensions } from './dimensions';

export const commonStyles = {
  drawerFooter: {
    boxShadow: '0px -3px 7px 0px #0000000a'
  }
};

/**
 * Dark-mode shadow for a bar that sits above scrolling content.
 * @param {'down'|'up'} direction - Side of the bar that faces the content
 * @returns {string} CSS box-shadow
 */
export const getDarkBarShadow = direction =>
  `0 ${direction === 'up' ? -2 : 2}px 12px rgba(0, 0, 0, 0.5)`;

/**
 * Dark-mode styles for a drawer bar (header or footer) that sits above scrolling content: it uses
 * the raised surface one step above the drawer and a soft shadow cast toward the content. Returns an
 * empty object in light mode.
 * @param {Object} theme - MUI theme
 * @param {'down'|'up'} direction - Side of the bar that faces the content
 * @returns {Object} Style object to spread into the bar styles
 */
export const getDarkElevatedBarStyles = (theme, direction) =>
  isDarkTheme(theme)
    ? {
        backgroundColor: theme.palette.grey[300],
        boxShadow: getDarkBarShadow(direction)
      }
    : {};

export const GRADIENT = `linear-gradient(150deg, rgb(64, 86, 244) 0%, rgb(136, 114, 240) 50%, rgb(229, 72, 383) 100%)`;

export const getLargeDrawerPaperStyles = theme => ({
  width: componentDimensions.drawer.large.width,
  [theme.breakpoints.down(componentDimensions.drawer.large.breakpoint)]: {
    width: componentDimensions.drawer.large.responsiveWidth
  },
  ...(isDarkTheme(theme) && {
    '& .MuiCard-root': {
      backgroundColor: theme.palette.grey[200]
    },
    '& .MuiAppBar-colorDefault': {
      backgroundColor: theme.palette.background.paper
    }
  })
});
